module.exports = __webpack_public_path__ + "static/img/brazil.3fc8860.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/brazil.png
// module id = s4rr
// module chunks = 1